import axios from '@axios'

import qs from 'qs'

const prefixPath = '/api/product/category'
export default {

  saveOrUpdate(data) {
    return axios.post(`${prefixPath}/saveOrUpdate`, data)
  },

  toggleEnabled(data) {
    return axios.post(`${prefixPath}/toggleEnabled`, data)
  },

  delete(id) {
    return axios.post(`${prefixPath}/delete`, qs.stringify({
      id,
    }))
  },
  listAll() {
    return axios.get(`${prefixPath}/listAll`)
  },

  getNodeList() {
    return axios.get(`${prefixPath}/getNodeList`)
  },

}
